import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import {
  getProjectMemberInvites,
  ProjectMemberInviteWithOrgMember,
} from '@/features/projects/shared/api/get-project-member-invites';
import { InvitationStatus } from '@/shared/types/api';

type Props = Omit<
  UseQueryOptions<
    ProjectMemberInviteWithOrgMember[],
    unknown,
    ProjectMemberInviteWithOrgMember[]
  >,
  'queryKey' | 'queryFn'
> & {
  projectId: string;
  statuses?: InvitationStatus[];
};

export const getProjectMemberInvitesQueryKey = (projectId: string) => [
  'projectMemberInvites',
  projectId,
];

export const useProjectMemberInvitesQuery = ({
  projectId,
  statuses,
  ...props
}: Props) => {
  return useQuery({
    ...props,
    queryKey: getProjectMemberInvitesQueryKey(projectId),
    queryFn: () => getProjectMemberInvites({ projectId, statuses }),
    enabled: !!projectId,
  });
};
